module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('transition', {
    attrs: {
      "name": "cta-transition",
      "enter-active-class": "animated delay5s fadeIn",
      "leave-active-class": "animated delay0s fadeOut"
    }
  }, [(((_vm.hasEntered && _vm.display) && !_vm.powerSurge) && _vm.hasPowerSurge) ? _c('div', {
    staticClass: "power-surge-button noselect",
    attrs: {
      "title": _vm.label
    },
    on: {
      "click": function($event) {
        $event.stopPropagation();
        _vm.lightsOut($event)
      }
    }
  }, [_c('div', {
    staticClass: "inner"
  }, [_c('div', {
    staticClass: "icon"
  }, [_c('i', {
    class: _vm.icon,
    attrs: {
      "aria-hidden": "true"
    }
  })]), _vm._v(" "), _c('div', {
    staticClass: "label"
  }, [_vm._v(_vm._s(_vm.label))])])]) : _vm._e()])
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-210d3647","hasScoped":true,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"}}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/components/PowerSurgeButton.vue
// module id = 450
// module chunks = 1